import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { consoleLog, decryptData, encryptData, getHeaderConfig } from "helpers";

/**
 * The analytics relay app-frontend sends every GA event through: app-backend's
 * UserController.sendPixelEvent, which queues `type: "lambda"` events on the GA
 * events SQS queue for Ariadne.
 *
 * Token-exempt (app-backend app/Jwt.ts), so it is posted the way the other
 * pre-token calls are (portalAuthAPI's postLogin, partnerSignupAPI): encrypted,
 * with `x-api-key` and no session. It deliberately does NOT go through
 * portalClient.postToBackend, because that refreshes or signs out the session
 * when a call fails, and an analytics call must never touch the session — most
 * sign-in events fire before one exists.
 *
 * Fire-and-forget. The caller logs the complete request (partner/analytics/
 * GAEvents.js, the "GA EVENTS" line); only a transport failure is logged here,
 * as app-frontend does.
 */
const PIXEL_EVENT_URL = `${ENDPOINT}/app/v1/facebook/pixelEvent`;

/** The request exactly as it is sent, before encryption — what the caller logs. */
export const pixelEventRequest = (eventName, eventData) => ({
  url: PIXEL_EVENT_URL,
  body: { eventName, eventData, bypassJWTValidation: true },
});

// Same two parses as portalClient's unwrap: decryptData parses once, and the
// server encrypts a payload Fastify has already serialised.
const readResponse = (raw) => {
  try {
    const once = decryptData(raw);
    return typeof once === "string" ? JSON.parse(once) : once;
  } catch {
    return raw;
  }
};

export const sendPixelEvent = (eventName, request) =>
  axios
    .post(request.url, encryptData(request.body), getHeaderConfig(null, ""))
    .catch((error) =>
      consoleLog([
        "GA EVENTS failed",
        eventName,
        {
          status: error?.response?.status,
          body: error?.response?.data !== undefined ? readResponse(error.response.data) : error?.message,
        },
      ]),
    );
